import { global_hooks } from 'src/globals';
import Hooks from 'js/hooks';
import { create_div, onscreen } from 'js/utils';
import './load_more.scss';

const button_text = 'Load more';
const emulate_loading_time = 800;

global_hooks.on('listing/init', init);

function init(listing) {
	if (!listing.args.load_more) return;
	listing.hooks.on('load_all/complete', init_load_more);
}

function init_load_more(listing) {
	const load_more = {
		hooks: new Hooks(),
	};

	let items = listing.items;
	let current_page = 1;
	let is_loading = false;

	const posts_per_page = listing.args.post_count;

	listing.load_more = load_more;

	const get_load_more_items = () => {
		const load_more_items = [];
		const start = posts_per_page * current_page;
		const end = posts_per_page * (current_page + 1);

		for (let i = start; i < end; i++) {
			load_more_items.push(items[i]);

			if (typeof items[i + 1] === 'undefined') {
				return load_more_items;
			}
		}

		return load_more_items;
	};

	const load_more_items = () => {
		if (is_loading) return;
		is_loading = true;

		load_more.hooks.do('load_more_items/before');

		listing.hooks.do('show_items', get_load_more_items());

		const have_more_posts =
			typeof items[posts_per_page * (current_page + 1)] !== 'undefined';
		load_more.hooks.do('update', have_more_posts);

		setTimeout(() => {
			is_loading = false;
			current_page++;
			load_more.hooks.do('load_more_items/after');
		}, emulate_loading_time);
	};

	const filter_result = (result) => {
		items = result;
		current_page = 1;

		const have_more_posts = typeof items[posts_per_page] !== 'undefined';
		load_more.hooks.do('update', have_more_posts);

		return result.slice(0, posts_per_page);
	};

	init_button(listing);
	init_auto_trigger(listing);

	load_more.hooks.on('load_more_items', load_more_items);
	listing.hooks.add_filter('filter_results/items_to_show', filter_result);
}

function init_button(listing) {
	const con = create_div('load_more_con');
	listing.container.after(con);
	listing.load_more_con = con;

	const load_more = listing.load_more;

	const btn = create_div('btn load_more_btn', con, button_text);

	const loading = () => {
		con.classList.add('loading');
	};

	const loading_end = () => {
		con.classList.remove('loading');
	};

	const update = (have_more_posts) => {
		con.style.display = have_more_posts ? '' : 'none';
	};

	btn.addEventListener('click', () => {
		load_more.hooks.do('load_more_items');
	});

	load_more.hooks.on('load_more_items/before', loading);
	load_more.hooks.on('load_more_items/after', loading_end);
	load_more.hooks.on('update', update);
}

function init_auto_trigger(listing) {
	if (!listing.args.load_more_auto) return;

	const trigger = create_div('load_more_auto_trigger', listing.load_more_con);

	onscreen(trigger, {
		on: () => {
			listing.load_more.hooks.do('load_more_items');
		},
	});
}
